var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteHighlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0013 16.4102H2.66797C1.93197 16.4102 1.33464 15.8128 1.33464 15.0768V3.74349H0.667969V2.41016H4.66797V1.41016C4.66797 0.858823 5.11664 0.410156 5.66797 0.410156H9.0013C9.5513 0.410156 10.0013 0.85749 10.0013 1.41016V2.41016H14.0013V3.74349H13.3346V15.0768C13.3346 15.8128 12.7373 16.4102 12.0013 16.4102ZM12.0013 3.74349H2.66797V14.7435C2.66797 14.9275 2.8173 15.0768 3.0013 15.0768H11.668C11.852 15.0768 12.0013 14.9275 12.0013 14.7435V3.74349ZM6.0013 6.41016C6.0013 6.04216 5.70264 5.74349 5.33464 5.74349C4.96664 5.74349 4.66797 6.04216 4.66797 6.41016V12.4102C4.66797 12.7782 4.96664 13.0768 5.33464 13.0768C5.70264 13.0768 6.0013 12.7782 6.0013 12.4102V6.41016ZM10.0013 6.41016C10.0013 6.04216 9.70263 5.74349 9.33463 5.74349C8.96663 5.74349 8.66797 6.04216 8.66797 6.41016V12.4102C8.66797 12.7782 8.96663 13.0768 9.33463 13.0768C9.70263 13.0768 10.0013 12.7782 10.0013 12.4102V6.41016ZM8.66797 1.74349H6.0013V2.41016H8.66797V1.74349Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteHighlight);
export default __webpack_public_path__ + "static/media/delete-highlight.a31e3f7cfda5e02fa8a73b044f055e5e.svg";
export { ForwardRef as ReactComponent };